
import { Vue, Component, Prop } from "vue-property-decorator";

import InformationWrapper from "@/components/inforationCards/InformationWrapperNew.vue";
import InformationCard from "@/components/inforationCards/InformationCardNew.vue";
import InformationEmptyAboutCard from "@/components/inforationCards/InformationEmptyAboutCardNew.vue";
import PageHeadIcon from "@/components/page/PageHeadIconNew.vue";
import FormattedDescription from "@/components/common/FormattedDescription.vue";
import ItemChip from "@/components/common/ItemChip.vue";
import InformationSection from "@/components/inforationCards/InformationSection.vue";
import ImageSample from "@/components/common/ImageSample.vue";
import Slider from "@/components/common/SliderNew.vue";
import VideoPlayer from "@/components/common/VideoPlayerNew.vue";
import DownloadResume from "@/components/profile/DownloadResume.vue";
import ExperienceCard from "@/components/profile/ExperienceCardNew.vue";
import EducationCard from "@/components/profile/EducationCardNew.vue";
import CertificationCard from "@/components/profile/CertificationCardNew.vue";
import CardPagination from "@/components/card/CardPagination.vue";
import UIButton from "@/components/button/ui-button.vue";
import UiButton from "@/components/button/ui-button-message.vue";
import ChipsWithMore from "@/components/common/ChipsWithMoreResource.vue";
import LoadingOverlay from "@/components/common/LoadingOverlay.vue";
import NewTabLink from "@/components/common/NewTabLink.vue";
import ItemChipsWithMore from "@/components/common/ItemChipsWithMoreNew.vue";
import CardBodyItem from "@/components/card/CardBodyItemNew.vue";
import CollapsibleDescription from "@/components/common/CollapsibleDescriptionNew.vue";
import EmptyListImageDocuments from "@/components/icons/emptyListImages/EmptyListImageContractorDocuments.vue";
import EmptyResourceInformationPlaceholder from "@/components/common/EmptyResourceInformationPlaceholderNew.vue";
import ResourceDataTable from "@/components/contractors/ResourceDataTableNew.vue";
import { NO_INFORMATION } from "@/data/placeholders";
import {
	getSkillsForChips,
	getLanguagesForChips,
	getIndustriesForChips,
} from "@/helpers/cardInfoHelperFunctions/chipDataHelpers";
import ManagementAddContractorInfo from "@/components/contractors/ManagementAddContractorInfoNew.vue";
import AddResumeModal from "@/components/contractors/AddResumeModal.vue";
import {
	Experience_Skill,
	User_Education,
	User_Certification,
	User_Experience,
	User_Profile,
	User_Profile_By_Management,
	Resource_Information_Card,
} from "@/generated/graphql";
import GET_PROFILE_DETAILS_BY_MANAGEMENT_ALL from "@/apollo/profile/profileDetails/management/GetProfileDetailByManagementAll.gql";
import ItemChipsData from "@/entities/ItemChipsData";
import CrossIcon from "@/components/icons/CrossIconNew.vue";
import CrossIconHover from "@/components/icons/CrossIconHover.vue";
import { Maybe } from "node_modules/graphql/jsutils/Maybe";
import getStateProvinceSelectTitle from "@/helpers/locations/getStateProvinceSelectTitle";
import { Contractor } from "@/interface";
import ChipWithLinkData from "@/types/ChipWithLinkData";
import REMOVE_EDUCATION from "@/apollo/profile/educations/RemoveEducation.gql";
import { NOTIFICATION } from "@/entities/Events";
import Message from "@/data/notificationsMessages";
import DownloadIcon from "@/components/icons/DownloadIconNew.vue";
import PaginationConfig from "@/entities/PaginationConfig";
import paginationConfig from "@/data/paginationConfig";

@Component({
	components: {
		InformationCard,
		InformationWrapper,
		NewTabLink,
		DownloadIcon,
		PageHeadIcon,
		FormattedDescription,
		ItemChip,
		InformationSection,
		ImageSample,
		CrossIcon,
		CrossIconHover,
		Slider,
		ChipsWithMore,
		VideoPlayer,
		DownloadResume,
		ExperienceCard,
		EducationCard,
		CertificationCard,
		ManagementAddContractorInfo,
		LoadingOverlay,
		ItemChipsWithMore,
		UiButton,
		CardBodyItem,
		CollapsibleDescription,
		EmptyListImageDocuments,
		InformationEmptyAboutCard,
		EmptyResourceInformationPlaceholder,
		ResourceDataTable,
		AddResumeModal,
		CardPagination,
		UIButton,
	},
	apollo: {
		profilesByManagement: {
			query: GET_PROFILE_DETAILS_BY_MANAGEMENT_ALL,
			variables() {
				return {
					userId: this.contractorUserId,
				};
			},
			update(data) {
				if (data.user_profile_by_management.length === 0)
					this.showDiscalimer = true;
				this.adminWork = data.user_profile_by_management.work_samples;
				return data.user_profile_by_management;
			},
		},
	},
})
export default class ContractorDetailedInformation extends Vue {
	// @Prop({ type: Array, default: () => [] })
	// readonly experiences!: Experience_Skill[];
	@Prop({ type: Array, default: () => [] })
	readonly educations!: User_Education[];
	@Prop({ type: Array, default: () => [] })
	readonly certifications!: User_Certification[];
	@Prop({ type: Object, required: true }) readonly profile!: User_Profile;
	@Prop({ type: Array, default: () => [] })
	readonly experiences!: User_Experience[];
	@Prop({ type: String, required: true }) readonly contractorId!: string;
	@Prop({ type: String, required: true }) readonly contractorUserId!: string;
	@Prop({ type: String, required: true }) readonly hasSource!: string;
	@Prop({ type: Array, default: () => [] })
	readonly resourceCard!: Resource_Information_Card[];
	@Prop({ type: String, required: true }) readonly currentUserId!: string;
	@Prop({ type: Boolean, required: false, default: true })
	readonly isAccessGranted!: boolean;

	contractor: Contractor[] = [];
	noInfo = NO_INFORMATION;
	showResume: boolean = false;
	paginationConfig: PaginationConfig = { ...paginationConfig };

	showManagementAddContractorInfoModal: boolean = false;
	profilesByManagement: User_Profile_By_Management[] = [];
	adminWork: [] = [];
	processing: boolean = false;
	showDiscalimer: boolean = false;
	isHovered: boolean = false;

	get contractorId_(): Object {
		return {
			contractor_id: this.contractorId,
		};
	}

	get secondaryItemClasses(): Record<string, boolean> {
		return {
			"py-4 border-primary-color": true,
		};
	}

	get getRateLength(): number | string {
		let length = 0;
		if (this.contractorRates.length) {
			length += 1;
		}
		return length > 0 ? `(${length})` : '';
	}

	get stateProvinceLabel(): string {
		const country = this.profile.country;
		return getStateProvinceSelectTitle([{ id: country!, name: country! }]);
	}

	get resourceCardStyles(): Object {
		return {
			[this.cardStyles]: this.resourceCard.length > 0,
		};
	}

	get demoReelStyles(): Object {
		return {
			[this.cardStyles]: this.demoReel,
		};
	}

	get experienceStyles(): Object {
		return {
			[this.cardStyles]: this.experiences.length > 0,
		};
	}

	get educationStyles(): Object {
		return "px-6";
	}

	get certificationStyles(): Object {
		return {
			[this.cardStyles]: this.certifications.length > 0,
		};
	}
	get containerStyles(): string {
		return "px-6";
	}
	get cardStyles(): string {
		return "pb-4";
	}


	get demoReel(): Maybe<string> | undefined {
		return this.profile.demo_reel !== "" ? this.profile.demo_reel : null;
	}

	get workSamples() {
		if (this.loading) return null;
		return this.profile?.work_samples?.length > 0 ? this.profile?.work_samples : null;
	}

	get skills(): ItemChipsData[] {
		const skills = this.profile.skills.reduce(function (filtered, userSkill) {
			if (!userSkill.added_by_id) {
				filtered.push(userSkill.skill);
			}
			return filtered;
		}, []);
		return getSkillsForChips(skills);
	}

	get skills2(): ChipWithLinkData[] {
		const skills = this.profile.skills.reduce(function (filtered, userSkill) {
			if (!userSkill.added_by_id) {
				let chipWithLinkData: ChipWithLinkData = {
					variant: "blue",
					chipLink: {},
					chipData: {
						id: userSkill.skill.id.toString(),
						name: userSkill.skill.name,
					},
					avatar: "",
					chipText: "",
				};
				filtered.push(chipWithLinkData);
			}
			return filtered;
		}, []);
		skills.sort((a, b) => a.variant.localeCompare(b.variant));
		return skills;
	}

	get industries(): ItemChipsData[] {
		const industries = this.profile.industries.reduce(function (
			filtered,
			industry
		) {
			if (!industry.added_by_id) {
				filtered.push(industry.industry);
			}
			return filtered;
		},
			[]);
		return getIndustriesForChips(industries);
	}

	openModal(): void {
		this.showResume = true;
	}

	closeModal(): void {
		this.showResume = false;
	}
	get industries2(): ChipWithLinkData[] {
		const industries = this.profile.industries.reduce(function (
			filtered,
			industry
		) {
			if (!industry.added_by_id) {
				let chipWithLinkData: ChipWithLinkData = {
					variant: "blue",
					chipLink: {},
					chipData: {
						id: industry.industry.id.toString(),
						name: industry.industry.name,
					},
					avatar: "",
					chipText: "",
				};
				filtered.push(chipWithLinkData);
			}
			return filtered;
		},
			[]);
		industries.sort((a, b) => a.variant.localeCompare(b.variant));
		return industries;
	}

	get languages(): ItemChipsData[] {
		const languages = this.profile.languages.reduce(function (
			filtered,
			language
		) {
			if (!language.added_by_id) {
				filtered.push(language.language);
			}
			return filtered;
		},
			[]);
		return getLanguagesForChips(languages);
	}

	get languages2(): ChipWithLinkData[] {
		const languages = this.profile.languages.reduce(function (
			filtered,
			language
		) {
			if (!language.added_by_id) {
				let chipWithLinkData: ChipWithLinkData = {
					variant: "blue",
					chipLink: {},
					chipData: {
						id: language.language.id.toString(),
						name: language.language.name,
					},
					avatar: "",
					chipText: "",
				};
				filtered.push(chipWithLinkData);
			}
			return filtered;
		},
			[]);
		languages.sort((a, b) => a.variant.localeCompare(b.variant));
		return languages;
	}

	get contractorRates(): ItemChipsData[] {
		if (!this.profile) {
			return [];
		}
		const currency = this.profile?.currency;
		const rateUnit = this.profile?.rate_unit;
		const minRate = this.profile?.min_rate;
		const maxRate = this.profile?.max_rate;

		if (!minRate && !maxRate && !currency && !rateUnit) {
			return [];
		}

		var maximumRates = [];
		let rate = "";
		if (minRate) rate += `${minRate}`;
		if (minRate && maxRate) rate += ` - ${maxRate}`;
		if (!minRate && maxRate) rate += `${maxRate}`;
		if (currency) rate += ` ${currency}`;
		if (rateUnit) rate += `/${rateUnit}`;
		if (minRate && maxRate) {
			maximumRates.push({ id: this.contractorId, name: rate });
		}
		return maximumRates;
	}

	get getDemoCount(): string {
		let length = 0;
		if (this.demoReel !== null) {
			length += 1;
		}
		return length > 0 ? `(${length})` : "";
	}
	get getWorkCount(): string {
		let length = 0;
		if (this.workSamples !== null) {
			length += this.workSamples.length;
		}
		return length > 0 ? `(${length})` : "";
	}

	showModal(): void {
		this.$emit("open");
	}

	refreshPage(): void {
		this.$emit("refresh");
	}
	async refetchprofilesByManagement(): Promise<void> {
		this.processing = true;
		await this.$apollo.queries.profilesByManagement.refetch();
		this.processing = false;
	}

	get loading(): boolean {
		if (this.$apollo.queries.profilesByManagement.loading || this.processing) {
			return true;
		}
		return false;
	}
}
